import React, { useEffect, useState } from "react";
import { useAppKitAccount, useDisconnect } from "@reown/appkit/react";
import PagesIndex from "../../PagesIndex";
import WalletLoader from "../../../components/common/WalletLoader";


export default function DisconnectWallet() {
  const navigate = PagesIndex.useNavigate();
  const location = PagesIndex.useLocation();
  const themeColor = new URLSearchParams(location.search).get("mode");

  const { address } = useAppKitAccount();
  const { disconnect } = useDisconnect();
  const [isVisible, setIsVisible] = useState(true);

  async function handleSell() {
    disconnect();
    navigate("/wallet/disconnected");
  }
  async function backToApp() {
    navigate("/wallet/disconnected");
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div
        //className="wallet-box"
        className={`${
          themeColor === "dark"
            ? "wallet-box wallet-box-content-dark"
            : "wallet-box wallet-box-content"
        }`}
      >
        <div className="wallet-box-cont">
          <div className="logo-box">
            <img src={PagesIndex.Png.logo2} alt="" />
            <div className="logo-title">EPISAP</div>
          </div>
    
          <div className="wallet-btn-approve">
            {!address && (
              <div className="wallet-title-box">
                <div className="logo-title">Wallet Disconnected</div>
                <button onClick={() => backToApp()}>Click To Connect</button>
              </div>
            )}
          </div>
          <div className="wallet-btn-approve">
            {address && (
              <button onClick={() => handleSell()}>Disconnect</button>
            )}
          </div>
        </div>
      </div>
      {isVisible && (
        <div className="wallet-loader">
          <WalletLoader />
        </div>
      )}
    </>
  );
}
